// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"CompanySetupModal_backdrop__2mwUF","dialog":"CompanySetupModal_dialog__ih53D"};